import { Star, ExternalLink } from "lucide-react";

const GoogleReviews = () => {
  const reviews = [
    {
      name: "Rahul Sharma",
      rating: 5,
      text: "BrandBorn helped us get listed on Myntra in just 12 days. Their team handled everything from documentation to catalog creation. Highly recommended!",
      time: "2 weeks ago"
    },
    {
      name: "Priya Patel",
      rating: 5,
      text: "Best onboarding agency in India. We tried doing it ourselves for months but failed. BrandBorn got us approved on Nykaa and Ajio in one go. 98% approval rate is real!",
      time: "1 month ago"
    },
    {
      name: "Vikram Singh",
      rating: 5,
      text: "Anmol and his team are amazing. Got our FMCG brand on Blinkit and Zepto within 2 weeks. The AI catalog tool ecomcatalog.ai saved us so much time.",
      time: "3 weeks ago"
    },
    {
      name: "Sneha Reddy",
      rating: 5,
      text: "We launched our beauty brand on Nykaa, Myntra and Tata Cliq with BrandBorn. The dedicated growth manager made all the difference. Revenue grew 3x in 2 months!",
      time: "1 month ago"
    },
    {
      name: "Amit Jain",
      rating: 5,
      text: "Excellent service! BrandBorn is the real deal. They got our ethnic wear brand on Ajio and Myntra with zero rejections. Their catalog quality is top-notch.",
      time: "2 months ago"
    },
    {
      name: "Deepika Gupta",
      rating: 5,
      text: "From Surat to selling on Myntra — BrandBorn made it possible. Very professional team, transparent pricing, and they deliver what they promise.",
      time: "3 weeks ago"
    }
  ];

  return (
    <section className="py-16 md:py-20 px-4 bg-gray-50" data-testid="google-reviews-section">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-xs font-black tracking-widest mb-4">
            <Star size={14} className="fill-white" />
            GOOGLE REVIEWS
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black mb-4">
            What Our Clients Say
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="flex">
              {[1,2,3,4,5].map(i => (
                <Star key={i} size={24} className="text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <span className="text-2xl font-black text-black">4.9</span>
            <span className="text-gray-500 font-medium">/ 5.0</span>
          </div>
          <p className="text-gray-500">Based on Google Reviews</p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto mb-10">
          {reviews.map((review, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-red-500 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              data-testid={`google-review-${idx}`}
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-3">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} size={16} className="text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              
              {/* Text */}
              <p className="text-gray-700 text-sm leading-relaxed mb-4">"{review.text}"</p>
              
              {/* Author */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-red-600 flex items-center justify-center text-white font-black text-sm">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <p className="text-black font-bold text-sm">{review.name}</p>
                    <p className="text-gray-400 text-xs">{review.time}</p>
                  </div>
                </div>
                <svg className="w-5 h-5 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="https://share.google/grSMHGsawZRtWFitv"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-black text-white rounded-xl font-bold text-sm hover:bg-gray-900 transition-all"
          >
            See All Reviews on Google
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
